import { render, staticRenderFns } from "./collectingActivities.vue?vue&type=template&id=926ce7be&scoped=true&"
import script from "./collectingActivities.vue?vue&type=script&lang=js&"
export * from "./collectingActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926ce7be",
  null
  
)

export default component.exports